import { Routes, Route, Navigate } from "react-router-dom";
import "@/pos/pos.css";
import { AuthProvider, useAuth } from "@/pos/context/AuthContext";
import Layout from "@/pos/components/Layout";
import Home from "@/pos/pages/Home";
import POS from "@/pos/pages/POS";
import Sales from "@/pos/pages/Sales";
import Customers from "@/pos/pages/Customers";
import CustomerDetail from "@/pos/pages/CustomerDetail";
import Cashbook from "@/pos/pages/Cashbook";
import Reports from "@/pos/pages/Reports";
import Settings from "@/pos/pages/Settings";
import { Receipt, Invoice } from "@/pos/pages/PrintDocs";
import Tables from "@/pos/pages/Tables";
import Kitchen from "@/pos/pages/Kitchen";
import TableBill from "@/pos/pages/TableBill";

function Protected({ children, owner }) {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-slate-500">Memuatkan...</div>;
  if (!user) return <Navigate to="/sign-in" replace />;
  if (owner && user.role !== "owner") return <Navigate to="/pos" replace />;
  return children;
}

const O = ({ children }) => <Protected owner>{children}</Protected>;

export default function PosApp() {
  return (
    <AuthProvider>
      <div className="pos-root">
        <Routes>
          <Route path="cetak/resit/:id" element={<Protected><Receipt /></Protected>} />
          <Route path="cetak/invois/:id" element={<Protected><Invoice /></Protected>} />
          <Route path="cetak/bil/:id" element={<Protected><TableBill /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route index element={<Home />} />
            <Route path="order" element={<POS />} />
            <Route path="meja" element={<Tables />} />
            <Route path="dapur" element={<Kitchen />} />
            <Route path="jualan" element={<Sales />} />
            <Route path="pelanggan" element={<Customers />} />
            <Route path="pelanggan/:id" element={<CustomerDetail />} />
            <Route path="tunai" element={<O><Cashbook /></O>} />
            <Route path="laporan" element={<O><Reports /></O>} />
            <Route path="tetapan" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/pos" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}
